// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"777":"cc6c8c4f","857":"3d93dc40","860":"4d379a74"}[chunkId] + ".chunk.css";
};